import React from "react";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { isEmpty } from "lodash";

import Grid from "@material-ui/core/Grid";

import colors from "../../assets/style/colors";

const styles = {
  subMenuItem: {
    cursor: "pointer",
    height: "40px",
    lineHeight: "40px",
    padding: "0px 20px",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const SubMenuElement = (props) => {
  const { history, classes, subPage, closeParent } = props;

  const handleClose = () => {
    closeParent();
  };

  const handleClick = (url) => {
    history.push(url);
    handleClose();
  };

  return (
    <Grid
      item
      className={classes.subMenuItem}
      onClick={() => handleClick(subPage.url)}
    >
      <Grid container alignItems="center">
        {!isEmpty(subPage.icons) && (
          <Grid
            item
            className="flexCenter"
            style={{ width: "50px", justifyContent: "center" }}
          >
            <img
              src={subPage.icons.black}
              alt="icon"
              style={{ maxWidth: "45px" }}
            />
          </Grid>
        )}
        <Grid item style={{ paddingLeft: "16px" }}>
          {I18n.get(`sidebar_${subPage.name}`)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withRouter(withStyles(styles)(SubMenuElement));
